
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/[bookId]/[bookPath]/[sheetId]",
      function () {
        return require("private-next-pages/books/[bookId]/[bookPath]/[sheetId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/[bookId]/[bookPath]/[sheetId]"])
      });
    }
  